import { Repository, RepositoryBase } from '@/repository/base';
import GoodsGetCondition from '@/models/goods/apiParam/GoodsGetCondition';
import GoodsPurchaseParam from '@/models/goods/apiParam/GoodsPurchaseParam';

/**
 * 物販関連リポジトリアクセス
 */
export default class GoodsRepository extends RepositoryBase {
  private repository = '/goods';

  private repositoryPurchasedGoods = '/goods_purchased';

  /**
   * 物販検索
   */
  getGoodsList() {
    const config = {
      headers: {
        'x-exam-key': process.env.VUE_APP_EXAM_SECRET_KEY,
      },
    };
    return Repository.get(`${this.repository}`, config);
  }

  /**
   * 物販取得
   * @param goodsCode 物販コード
   * @param params 検索条件（料金設定有無を含めるか否か）
   */
  getGoods(goodsCode: string, params: GoodsGetCondition = new GoodsGetCondition()) {
    const config = {
      headers: {
        'x-exam-key': process.env.VUE_APP_EXAM_SECRET_KEY,
      },
      params: this.convert.serialize(params),
      paramsSerializer: (paramsObj: GoodsGetCondition) => this.paramsUrlEncode<GoodsGetCondition>(paramsObj),
    };
    return Repository.get(`${this.repository}/${goodsCode}`, config);
  }

  /**
   * 購入済みグッズ一覧
   */
  getPurchasedGoodsList() {
    const config = {
      headers: {
        'x-exam-key': process.env.VUE_APP_EXAM_SECRET_KEY,
      },
    };
    return Repository.get(`${this.repositoryPurchasedGoods}`, config);
  }

  /**
   * グッズ購入
   * @param param 購入用パラメータ
   * @returns レスポンス
   */
  purchaseGoods(param: GoodsPurchaseParam) {
    const config = {
      headers: {
        'x-exam-key': process.env.VUE_APP_EXAM_SECRET_KEY,
      },
    };
    return Repository.post(`${this.repository}/${param.goodsCode}`, this.convert.serialize(param), config);
  }
}
